import classNames from 'classnames';
import PropTypes from 'prop-types';

import icons from './icons';
import style from './style.module.css';

export const TeesterIcon = ({ type, color = 'var(--primary-color)', title = '', spin = false, className = '', onClick = null }) => {
  const icon = icons[type];
  const playIconClassName = type === "PLAY" ? style.playButton : ''
  const iClassName = classNames({ [style.clickable]: onClick, [style.spin]: spin }, style.icon, className, playIconClassName);

  if (icon) {
    const { Icon, iconStyle } = icon;
    return <Icon className={classNames(iClassName)} style={iconStyle(color)} title={title} onClick={onClick} />;
  }

  return null;
};

TeesterIcon.propTypes = {
  type: PropTypes.oneOf(Object.keys(icons)),
  color: PropTypes.string,
  title: PropTypes.string,
  spin: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default TeesterIcon;
